import type { HelpFile } from '../../types/help'
import { AccessProfilesTestIds } from '../../../testids/AccessProfilesTestIds'

export const accessProfilesHelp: HelpFile = {
  docPage: '/docs/access/entitlements',
  texts: {
    [AccessProfilesTestIds.accessProfilesList]:
      'Übersicht aller Zugriffsprofile — benannte Bündel von Enforcement-Objekten, die beantragt oder automatisch zugewiesen werden können.',
    [AccessProfilesTestIds.btnCreateProfile]: null,
    [AccessProfilesTestIds.colAutoAssignable]:
      'Ob eine Auto-Zuweisungsregel dieses Profil ohne Antrag vergeben darf.',
    [AccessProfilesTestIds.colRequestable]:
      'Ob Parteien dieses Profil über den Zugriffsantrag anfordern können.',
  },
}
